import { pl } from './pl';
import { uk } from './uk';
import { ru } from './ru';

export type Lang = 'pl' | 'uk' | 'ru';

/**
 * Full set of translation keys used across the cabinet.
 * When migrating to Next.js — this type stays unchanged.
 */
export type TranslationKeys = {
  // Auth — Login
  login_hi: string;
  login_title: string;
  login_label: string;
  login_title2: string;
  login_choose: string;
  login_no_password_hint: string;
  phone_placeholder: string;
  login_sub_email: string;
  forgot: string;
  login_by_phone: string;
  or: string;
  password: string;
  login_btn: string;
  cont_google: string;
  cont_apple: string;
  no_account: string;
  no_account_sub: string;
  create_account: string;
  // Auth — Register
  reg_title: string;
  reg_sub: string;
  firstname: string;
  lastname: string;
  id_doc: string;
  pesel: string;
  passport: string;
  reg_btn: string;
  consent1: string;
  consent2: string;
  // Auth — Register Phone (нові ключі)
  reg_phone_title: string;
  reg_phone_sub: string;
  reg_firstname: string;
  reg_lastname: string;
  consent1_text: string;
  consent2_text: string;
  no_account_yet_msg: string;
  login_no_account_msg: string;
  err_firstname_empty: string;
  err_lastname_empty: string;
  err_consent_required: string;
  reg_login_link: string;
  // Auth — OTP & Phone
  otp_title: string;
  otp_sub: string;
  confirm: string;
  resend: string;
  phone_label: string;
  send_sms_btn: string;
  change_number: string;
  otp_sent_hint: string;
  resend_timer: string;
  err_phone_empty: string;
  err_phone_format: string;
  err_sms_failed: string;
  err_otp_invalid: string;
  err_otp_expired: string;
  err_otp_rate_limit: string;
  reset_pw_title: string;
  reset_pw_sent: string;
  login_with_sms: string;
  login_with_email: string;
  // Network Errors Fallback
  err_network: string;
  err_fill_all_to_enter_code: string;
  err_phone_to_enter_code: string;
  btn_have_code: string;
  // Auth — Thank You
  thanks_title: string;
  thanks_sub: string;
  go_account: string;
  go_back: string;
  // Navigation
  nav_cons: string;
  nav_cons_short: string;
  nav_terapia: string;
  nav_terapia_short: string;
  nav_uslugi: string;
  nav_uslugi_s: string;
  nav_umow: string;
  btn_umow: string;
  nav_doc: string;
  nav_dane: string;
  logout: string;
  // Consultations
  greet_title: string;
  greet_sub: string;
  cons_actual: string;
  cons_done: string;
  status_upcoming: string;
  status_done: string;
  cons_cancelled: string;
  status_cancelled: string;
  status_pending: string;
  pay_for_visit: string;
  status_nieudane: string;
  contact_support: string;
  order_no: string;
  show_more: string;
  show_less: string;
  weight: string;
  by_phone: string;
  online: string;
  reschedule: string;
  rebook: string;
  empty_cons: string;
  empty_cons_sub: string;
  empty_cons_cta: string;
  visit_summary: string;
  cons_empty_tab: string;
  cons_show_more: string;
  cons_collapse: string;
  spec1: string;
  spec_tele: string;
  cons_find_point: string;
  cons_find_point_link: string;
  cons_checkup_results_btn: string;
  cons_download_referral: string;
  // Therapy
  terapia_title: string;
  terapia_intro: string;
  last_visit: string;
  rec_control: string;
  book_control: string;
  // Services
  uslugi_title_a: string;
  cs_recepta: string;
  cs_recepta_d: string;
  cs_anty: string;
  cs_anty_d: string;
  cs_l4: string;
  cs_l4_d: string;
  cs_tele: string;
  cs_tele_d: string;
  cs_check: string;
  cs_check_d: string;
  glp_t: string;
  glp_d: string;
  svc_analizy: string;
  svc_analizy_d: string;
  svc_portal: string;
  svc_portal_d: string;
  // Documents
  doc_all: string;
  doc_recepty: string;
  doc_skier: string;
  doc_wyniki: string;
  doc_moje: string;
  doc_l4: string;
  doc_zalecenia: string;
  add_file: string;
  empty_doc: string;
  add_file_sub: string;
  upload_txt: string;
  upload_max: string;
  upload_formats: string;
  upload_blocked_hint: string;
  doc_delete_confirm: string;
  doc_title_desktop: string;
  doc_title_mobile: string;
  doc_no_files: string;
  doc_default_name: string;
  doc_upload_title: string;
  doc_close: string;
  doc_choose_file: string;
  doc_uploaded_file: string;
  doc_delete_selected: string;
  doc_send_to_doctor: string;
  doc_prescription_title: string;
  doc_prescription_code: string;
  doc_code: string;
  doc_pickup_title: string;
  doc_pickup_desc_1: string;
  doc_pickup_desc_2: string;
  doc_pickup_desc_3: string;
  doc_pickup_desc_4: string;
  doc_prescriptions_heading: string;
  doc_download_pdf: string;
  doc_print_save_pdf: string;
  doc_all_files: string;
  // Profile
  dane_personal: string;
  dane_addr: string;
  dane_contact: string;
  security: string;
  sex: string;
  female: string;
  male: string;
  tz: string;
  street: string;
  city: string;
  country: string;
  phone_short: string;
  err_phone: string;
  edit: string;
  change: string;
  cancel: string;
  save: string;
  edit_your: string;
  // Reschedule
  resch_title: string;
  resch_intro: string;
  resch_current: string;
  resch_doctor: string;
  resch_pick: string;
  resch_confirm: string;
  resch_ok_t: string;
  resch_ok_s: string;
  back_cons: string;
  // Toasts
  toast_soon: string;
  toast_portal: string;
  toast_added: string;
  toast_saved: string;
  toast_pass: string;
  toast_deleted: string;
  // Email verification
  verify_email_banner: string;
  verify_email_cta: string;
  verify_email_sent: string;
  verify_email_title_existing: string;
  verify_email_sub_existing: string;
  // Set Password Form
  set_new_password_title: string;
  set_new_password_sub: string;
  new_password_placeholder: string;
  confirm_password_placeholder: string;
  set_password_btn: string;
  password_set_success: string;
  err_password_short: string;
  err_passwords_mismatch: string;
  my_account: string;
  passport_no: string;
  issue_country: string;
  issue_date: string;
  building: string;
  zipcode: string;
  email: string;
  push_notif: string;
  push_off_toast: string;
  push_on_toast: string;
  push_err_toast: string;
  turn_off: string;
  turn_on: string;
  add_email_title: string;
  add_email_sub: string;
  add_email_btn: string;
  err_email_send: string;
  terms_link: string;
  privacy_link: string;
  error_save: string;
  // New Missing Translations
  referral: string;
  prescription_title: string;
  password_placeholder: string;
  loading_dots: string;
  err_login_invalid: string;
  email_placeholder: string;
  show_hide_password: string;
  err_email_invalid: string;
  err_firstname_latin: string;
  err_lastname_latin: string;
  err_email_exists: string;
  err_rate_limit_10m: string;
  err_register_failed: string;
  err_reset_send: string;
  powrot: string;
  reset_pw_sub: string;
  err_set_password: string;
  auth_ready: string;
  auth_redirect_msg: string;
  push_prompt_msg: string;
  notifications: string;
  no_notifications: string;
  err_phone_min9: string;
  err_street_invalid: string;
  err_city_invalid: string;
  house_number: string;
  zip_code: string;
  empty_cons_btn: string;
  empty_cons_title: string;
  dr_prefix: string;
  synevo_package: string;
  blood_tests_package: string;
  doctor_alt: string;
  err_fetch_recommendations: string;
  doctor_recommendations: string;
  dietitian_recommendations: string;
  visit_no: string;
  no_recommendations: string;
  err_upload_file: string;
  no_visit_data: string;
  diagnosis: string;
  e_prescription: string;
  e_prescription_code: string;
  referrals_title: string;
  code_label: string;
  test_results_docs: string;
  sending: string;
  poland: string;
  ther_welcome_sub: string;
  ther_next_visit: string;
  ther_rec_date: string;
  ther_book_visit: string;
  ther_my_visits: string;
  ther_visits_desc: string;
  ther_tests: string;
  ther_tests_desc: string;
  ther_portal: string;
  ther_portal_desc: string;
  ther_extra_services: string;
  ther_extra_services_desc: string;
  doc_delete_err: string;
  doc_delete_btn: string;
  thanks_desc: string;
  thanks_no_order: string;
  back_to_dashboard: string;
  sick_note_from_to: string;
  err_load_slots: string;
  err_resch: string;
  resch_ok_p1: string;
  resch_ok_p2: string;
  med_cons: string;
  loading_slots: string;
  no_avail_slots: string;
  resch_new_time: string;
  any_doctor: string;
  doc_placeholder: string;
  resch_select_date: string;
  weekdays_short: string;
  synevo_any_point: string;

  // PWA Banner
  pwa_banner_title: string;
  pwa_banner_sub: string;
  pwa_banner_how: string;
  pwa_exp_title: string;
  pwa_exp_sub: string;
  pwa_welcome_coupon: string;
  pwa_back: string;
  
  pwa_s_1: string;
  pwa_s_2: string;
  pwa_s_2_badge: string;
  pwa_s_3: string;
  pwa_s_3_badge: string;
  pwa_s_4: string;
  pwa_s_4_badge: string;
  pwa_s_4_end: string;

  pwa_ci_1: string;
  pwa_ci_1_mid: string;
  pwa_ci_1_badge: string;

  pwa_ca_1: string;
  pwa_ca_1_end: string;
  pwa_ca_3: string;
  pwa_ca_3_badge1: string;
  pwa_ca_3_mid: string;
  pwa_ca_3_badge2: string;

  // Onboarding Tour
  tour_back: string;
  tour_next: string;
  tour_finish: string;
  tour_welcome: string;
  tour_notif: string;
  tour_a1: string;
  tour_a2: string;
  tour_a3: string;
  tour_a4: string;
  tour_a5: string;
  tour_b1: string;
  tour_b2: string;
  tour_b3: string;
  tour_b4: string;
  tour_pwa: string;
  print_save_pdf: string;
  close: string;
  push_later: string;
  // Referral modal keys
  doc_referral_title: string;
  doc_referral_code: string;
  doc_referral_type: string;
  doc_referral_diseases: string;
  doc_referral_procedures: string;
  doc_referral_reason: string;
  doc_referral_notes: string;
  doc_referral_urgent: string;
  doc_referral_empty: string;
  doc_referral_card_label: string;
  // Diet Plan
  diet_need_advice: string;
  diet_need_advice_sub: string;
  diet_check_offer: string;
  diet_plan_title: string;
  diet_plan_ready: string;
  diet_plan_prep: string;
  diet_plan_prep_desc: string;
  diet_plan_slot: string;
  diet_plan_desc: string;
  diet_plan_open: string;
  diet_plan_download: string;
  diet_plan_reorder: string;
  diet_plan_meet: string;
  diet_plan_zalecenia: string;
};

const translations: Record<Lang, TranslationKeys> = { pl, uk, ru };

/**
 * Creates a translator function for the given language.
 * Falls back to PL if a key is missing in the target language.
 *
 * Usage:
 *   const t = createTranslator('uk');
 *   t('login_btn') // → 'Увійти'
 *
 * Supports {name} interpolation:
 *   t('greet_title', { name: 'Olena' }) // → 'Вітаємо, Olena! 👋'
 *
 * When migrating to Next.js — replace the lang source:
 *   const lang = router.locale as Lang ?? 'pl';
 */
export function createTranslator(lang: Lang) {
  return function t(
    key: keyof TranslationKeys,
    vars?: Record<string, string>
  ): string {
    const value =
      translations[lang]?.[key] ??
      translations['pl'][key] ??
      key;

    if (!vars) return value;

    return Object.entries(vars).reduce(
      (acc, [k, v]) => acc.replace(`{${k}}`, v),
      value
    );
  };
}

export { pl, uk, ru };
